import styled from "styled-components";

export const PolicyWrapper = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor || "#ffffff"};
  color: ${({ textColor }) => textColor || "#333"};
  padding: 20px;
  max-width: 900px;
  margin: auto;
  line-height: 1.6;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const Heading = styled.h2`
  color: ${({ primaryColor }) => primaryColor || "#0066cc"};
  font-size: 1.5rem;
  margin-top: 30px;
  margin-bottom: 10px;
  scroll-margin-top: 80px;
`;

export const Paragraph = styled.p`
  margin-bottom: 12px;
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const List = styled.ul`
  margin-left: 20px;
  margin-bottom: 12px;
`;

export const ListItem = styled.li`
  margin-bottom: 6px;
`;
